import { graphql } from "gql.tada";
import { RichTextFragment } from "../fragments/RichTextFragment";
export const GetStartedSectionById = graphql(
  `
    query GetStartedSectionById(
      $locale: String
      $preview: Boolean
      $id: String!
    ) {
      getStartedSection(id: $id, preview: $preview, locale: $locale) {
        ...GetStartedSectionFragment
      }
    }

    fragment GetStartedSectionFragment on GetStartedSection {
      title
      description
      firstNameFieldLabel
      lastNameFieldLabel
      emailFieldLabel
      emailFieldInvalid
      titleFieldLabel
      businessPhoneNumberFieldLabel
      advertiserAgencyNameFieldLabel
      additionalAdvertiserFieldLabel
      websiteFieldLabel
      industryVerticalFieldLabel
      industryVerticalOptionsListCollection {
        items {
          label
          value
        }
      }
      advertisingMarketCountryLabel
      advertisingMarketCountryOptionsListCollection {
        items {
          label
          value
        }
      }
      usRegionLabel
      usRegionOptionsListCollection {
        items {
          label
          value
        }
      }
      estimatedCampaignBudgetLabel
      estimatedCampaignBudgetOptionsListCollection {
        items {
          label
          value
        }
      }
      estimatedAnnualSpendOnNetflixLabel
      estimatedAnnualSpendOnNetflixOptionsListCollection {
        items {
          label
          value
        }
      }
      preferredProgrammaticDspUsedLabel
      preferredProgrammaticDspUsedOptionsListCollection {
        items {
          label
          value
        }
      }
      additionalNotesLabel
      inquiryTypeLabel
      inquiryTypeOptionsListCollection {
        items {
          label
          value
        }
      }
      requiredFieldText
      submittedTitle
      submittedNote
      newsletterSignUpLabel
      termsConditionsCheckboxLabel {
        ...RichTextFragment
      }
      selectOption
      submitButtonLabel
      submittedLabel
      agencyLabel
      pleaseInputNa
    }
  `,
  [RichTextFragment]
);
